import React from 'react';
import { StyledFloatingCard, StyledFloatingTitleCard } from './FloatingCard.style';

function FloatingCard({ url, cardText, onClick }) {
  return (
    <StyledFloatingCard url={url} onClick={onClick}>
      <StyledFloatingTitleCard>{cardText}</StyledFloatingTitleCard>
    </StyledFloatingCard>
  );
}

export default FloatingCard;
